import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

// Short instant feedback banner: green "✓ Correct!" or red "✗ Not quite — try again". Never reveals the answer.
export const InstantFeedback = ({ feedback, testId = 'instant-feedback' }) => (
  <div aria-live="polite" className="min-h-[40px]">
    {feedback && (
      <div
        key={feedback.key}
        className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold animate-[fadeIn_0.2s_ease-out] ${
          feedback.ok ? 'bg-green-100 text-green-800 border border-green-300' : 'bg-red-100 text-red-700 border border-red-300'
        }`}
        data-testid={testId}
        data-result={feedback.ok ? 'correct' : 'incorrect'}
      >
        {feedback.ok ? <CheckCircle2 className="h-4 w-4" /> : <XCircle className="h-4 w-4" />}
        {feedback.ok ? '✓ Correct!' : '✗ Not quite — try again'}
      </div>
    )}
  </div>
);
